import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export const ErrorModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='custom-error-modal'
    >
      <Modal.Header closeButton={props.onHide}>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {props.bodyMessage}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}